<template>
  <div class="flex height100_hidden">
    <div class='left height100 left_ctn flexV'>
      <Logo></Logo>
      <div class="line line0 clearfix">
        <div class="txt0 inline_block">农产品</div>
        <div class="txt1 inline_block" v-if="list && list.length">{{summary.location_name || '全国'}}买卖走势</div>
      </div>
      <div class="line1 flex">
        <div class="flex1 line1_col flex">
          <div class="txt0 flex1" :class='summary.location_cnt | getFontSizeFromNum'>{{summary.location_cnt}}</div>
          <div class="home_line1_col1">覆盖<br>县市</div>
        </div>
        <div class="flex1 line1_col flex">
          <div class="txt0 flex1" :class='summary.product_cnt | getFontSizeFromNum'>{{summary.product_cnt}}</div>
          <div class="home_line1_col1">覆盖<br>产品</div>
        </div>
      </div>
      <div class="list_ctn flex1">
        <div class="list_srcoll">
          <div>  <!--非无用标签，解决未知原因出现滚动条时原素错位问题-->
            <div class="list_header clearfix">
              <div class="pull_left col">产品名称</div>
              <div class="pull_left text_right col">买家热度</div>
              <div class="pull_left text_right col">卖家热度</div>
            </div>
            <div @click="linkTo(index, { name: 'nationDetail', params: { id: item.product_id }, query: { index: index, province_id: $route.query.province_id }})" class="list_item pointer clearfix" v-for='(item, index) in items' :key='index'>
              <div class="pull_left col">{{item.product_name}}</div>
              <div class="pull_left text_right col">{{item.buy}}
                <div class="green inline_block" v-if='item.buy_rate < 0'>
                  <span class="arrow_down"></span>
                  <span class="rate_txt inline_block">{{item.buy_rate}}%</span>
                </div>
                <div class="red inline_block" v-else-if='item.buy_rate > 0'>
                  <span class="arrow_up" ></span>
                  <span class="rate_txt inline_block">{{item.buy_rate}}%</span>
                </div>
                <div class="white inline_block" v-else>
                  <span class="arrow_keep"></span>
                  <span class="rate_txt inline_block">{{item.buy_rate}}%</span>
                </div>
              </div>
              <div class="pull_left text_right col">{{item.sell}}
                <div class="green inline_block" v-if='item.sell_rate < 0'>
                  <span class="arrow_down"></span>
                  <span class="rate_txt inline_block">{{item.sell_rate}}%</span>
                </div>
                <div class="red inline_block" v-else-if='item.sell_rate > 0'>
                  <span class="arrow_up" ></span>
                  <span class="rate_txt inline_block">{{item.sell_rate}}%</span>
                </div>
                <div class="white inline_block" v-else>
                  <span class="arrow_keep"></span>
                  <span class="rate_txt inline_block">{{item.sell_rate}}%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Right class='flex1' :list='list' :summary='summary'></Right>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Right from '@/components/Right.vue'

export default {
  created () {
    this.$store.dispatch('home/getData', { provinceId: this.$route.query.province_id })
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState({
      isVIP: state => state.user.isVIP,
      summary: state => state.home.summary,
      items: state => state.home.items,
      list: state => state.home.list,
      provinceList: state => state.right.provinceList,
      loginStatus: state => state.user.loginStatus
    })
  },
  methods: {
    linkTo (index, params) {
      if (this.loginStatus === 2 && index >= 1) {
        this.$router.push({
          name: 'login'
        })
      } else {
        this.$router.push(params)
      }
    }
  },
  watch: {
    $route (to, from) {
      if (to.name === from.name && to.query.province_id !== from.query.province_id) {
        this.$store.dispatch('home/getData', { provinceId: to.query.province_id })
        const tempArr = this.provinceList.find(x => x.id === to.query.province_id - '')
        if (to.query.province_id - '') {
          this.$store.commit('right/setSelectedProvince', tempArr.name || '全国')
        } else {
          this.$store.commit('right/setSelectedProvince', '全国')
        }
      }
    }
  },
  components: {
    Right
  }
}
</script>
